const AuthenticationStatus = Object.freeze({
	Unknown: 'unknown',
	Visitor: 'visitor',
	Authenticated: 'authenticated',
});

export default AuthenticationStatus;
